import React from "react";
import LiveAudioVisualizer from "./LiveAudioVisualizer";
import useTitanApp from "../../../hooks/useTitanApp";
import { IoChevronDown } from "react-icons/io5";
import { Button } from "../../ui/button";
import { formatTranscribingTime } from "../../../utils/formatTime";

export const TranscribingButton = ({
  showDropdown,
  setShowDropdown,
  handleUpdateButtonStatus,
  elapsedTime = 0
}) => {
  const { patientState } = useTitanApp();
  const {
    consultationStarted,
    isSummaryStreaming,
    selectedPatientConsultation,
  } = patientState || {};

  const RightChevron = () => (
    <div
      className={`right-icon ${consultationStarted ? "playing" : "stopped"}`}
      onClick={(e) => {
        e.stopPropagation();
        setShowDropdown((prev) => !prev);
      }}
    >
      <IoChevronDown size={14} color="#f2f2f2" />
    </div>
  );

  return (
    <Button className="d-flex bg-[#16a34a] hover:bg-[#22c55e]" onClick={handleUpdateButtonStatus}>
      <div className="icon-cont">
        <LiveAudioVisualizer isActive={true} className="viz" />
      </div>

      <div className="text-wrapper">
        <p className="transcribing-text">{formatTranscribingTime(elapsedTime)}</p>
      </div>

      <RightChevron />
    </Button>
  );
};
